import React,  { Component } from 'react'
import { Grid, Content } from '../components/Layout';
import Sidebar from '../components/Sidebar';
import styled from 'styled-components'
import Header from '../components/Header';

const ContentNotFound = styled(Content)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  h2, h5 {
      padding: 0;
      margin: .3em 0;
  }
  h5 {
      color: #999;
  }
`

export default class NotFound extends Component {
    render() {
        const { menuItems = [], router } = this.props
        return (
            <Grid>
              <Header router={router} />
              <Sidebar menuItems={menuItems} router={router} />
              <ContentNotFound>
                <div>
                    <h2>Esta página não existe</h2>
                    <h5>Por favor, selecione outro item do menu.</h5> <br />
                </div>
              </ContentNotFound>
            </Grid>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/NotFound.js